import Loc from "./localization";

const LocService = new Loc()
let TAB_CONFIG = {
    "HOME": {
        id: "HOME",
        name: LocService.t('label_home'),
        localizationId: 'label_home',
        iconClass: 'ti-home',
        showBalance: false,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_USER', 'ROLE_TRAINER'],
        route: '/home-page'
    },
    "ENTRANCE": {
        id: "ENTRANCE",
        name: LocService.t('label_entrance'),
        localizationId: 'label_entrance',
        iconClass: 'ti-view-grid',
        showBalance: false,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
        route: '/entrance'
    },
    "ENTRA_TRAINER": {
        id: "ENTRA_TRAINER",
        name: LocService.t('label_entrance'),
        localizationId: 'label_entrance',
        iconClass: 'ti-view-grid',
        showBalance: false,
        role: ['ROLE_TRAINER'],
        route: '/entrance'
    },
    "CSCHEDULE": {
        id: "CSCHEDULE",
        name: LocService.t('label_schedule'),
        localizationId: 'label_schedule',
        iconClass: 'ti-calendar',
        showBalance: false,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_TRAINER'],
        route: '/c-schedule'
    },
    "SHOP": {
        id: "SHOP",
        name: LocService.t('label_ci_shop'),
        localizationId: 'label_ci_shop',
        iconClass: 'ti-shopping-cart',
        showBalance: false,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN',],
        route: '',
        subMenu: [
            {
                id: "SHOP",
                name: LocService.t('label_ci_shop'),
                localizationId: 'label_ci_shop',
                iconClass: 'ti-shopping-cart',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN',],
                route: '/shop',
            },
            {
                id: "ORDERS",
                name: LocService.t('label_tab_orders'),
                localizationId: 'label_tab_orders',
                iconClass: 'ti-wallet',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/orders'
            },
            {
                id: "ORDR_RESERVATION",
                name: LocService.t('label_tab_orders_reservation'),
                localizationId: 'label_tab_orders_reservation',
                iconClass: 'ti-check',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/orders-reservation'
            },
            {
                id: "BAR_POS",
                name: LocService.t('label_bar_pos'),
                localizationId: 'label_bar_pos',
                iconClass: 'ti-cup',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN',],
                route: '/bar-pos',
            },
            {
                id: "WAREHOUSE",
                name: LocService.t('label_warehouse'),
                localizationId: 'label_warehouse',
                iconClass: 'ti-list',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN',],
                route: '/warehouses',
            },
            {
                id: "INVENTORY",
                name: LocService.t('label_inventory'),
                localizationId: 'label_inventory',
                iconClass: 'ti-pencil',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN',],
                route: '/inventory-history',
            },
        ]
    },
    "TRAININGS": {
        id: "TRAININGS",
        name: LocService.t('label_trainings'),
        localizationId: 'label_trainings',
        iconClass: 'ti-shield',
        showBalance: false,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_USER', 'ROLE_TRAINER'],
        route: '',
        subMenu: [
            {
                id: "TRAININGS",
                name: LocService.t('label_trainings'),
                localizationId: 'label_trainings',
                iconClass: 'ti-shield',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_USER', 'ROLE_TRAINER'],
                route: '/trainings',
            },
            {
                id: "TRN_TYPES",
                name: LocService.t('label_training_types'),
                localizationId: 'label_training_types',
                iconClass: 'ti-notepad',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/training-types'
            },
            {
                id: "SCHEDULE",
                name: LocService.t('label_terms'),
                localizationId: 'label_terms',
                iconClass: 'ti-alarm-clock',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/pre-terms'
            },
            {
                id: "WOD",
                name: LocService.t('label_wod'),
                localizationId: 'label_wod',
                iconClass: 'ti-notepad',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/wod'
            },
        ]
    },

    "TIMED_SLOTS": {
        id: "TIMED_SLOTS",
        name: LocService.t('label_timed_slots'),
        localizationId: 'label_timed_slots',
        iconClass: 'ti-alarm-clock',
        showBalance: false,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
        route: '/timed-slots'
    },

    "EMPLOYED_TRM": {
        id: "EMPLOYED_TRM",
        name: LocService.t('label_terms'),
        localizationId: 'label_terms',
        iconClass: 'ti-alarm-clock',
        showBalance: false,
        role: ['ROLE_TRAINER'],
        route: '/employed-terms'
    },

    "EMPLOYED_USR": {
        id: "EMPLOYED_USR",
        name: LocService.t('label_users'),
        localizationId: 'label_users',
        iconClass: 'ti-user',
        showBalance: false,
        role: ['ROLE_TRAINER'],
        route: '/employed-users'
    },

    "USERS": {
        id: "USERS",
        name: LocService.t('label_users'),
        localizationId: 'label_users',
        iconClass: 'ti-user',
        showBalance: false,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
        route: '',
        subMenu: [
            {
                id: "USERS",
                name: LocService.t('label_users'),
                localizationId: 'label_users',
                iconClass: 'ti-user',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/users'
            },
            {
                id: "CASHBACK_CREDIT",
                name: LocService.t('label_user_credit'),
                localizationId: 'label_user_credit',
                iconClass: 'ti-back-left',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/user-credits'
            },
            {
                id: "PERSONAL",
                name: LocService.t('label_personal'),
                localizationId: 'label_personal',
                iconClass: 'ti-user',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/personal'
            },

            {
                id: "CAMPAIGN",
                name: LocService.t('label_campaign'),
                localizationId: 'label_campaign',
                iconClass: 'ti-email',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/campaign-list'
            },
            {
                id: "BAR_SALDO_REPORT",
                name: LocService.t('label_bar_saldo_debtors'),
                localizationId: 'label_bar_saldo_debtors',
                iconClass: 'ti-money',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/bar-saldo-debtors'
            },
        ]
    },

    "PAYMENTS": {
        id: "PAYMENTS",
        name: LocService.t('label_reports'),
        localizationId: 'label_reports',
        iconClass: 'ti-money',
        showBalance: false,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
        route: '',
        subMenu: [
            {
                id: "PAYMENTS",
                name: LocService.t('label_payments'),
                localizationId: 'label_payments',
                iconClass: 'ti-money',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/payment-report'
            },
            {
                id: "PROFIT",
                name: LocService.t('label_profit'),
                localizationId: 'label_profit',
                iconClass: 'ti-money',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/profit'
            },
            {
                id: "USR_REPORT",
                name: LocService.t('label_user_report'),
                localizationId: 'label_user_report',
                iconClass: 'ti-user',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/user-report'
            },
            {
                id: "SUBSCRIPTIONS",
                name: LocService.t('label_subscriptions'),
                localizationId: 'label_subscriptions',
                iconClass: 'ti-money',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/subscription-report'
            },
            {
                id: "REPORT_TR",
                name: LocService.t('label_trainings_report'),
                localizationId: 'label_trainings_report',
                iconClass: 'ti-list',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/training-report',
            },
            {
                id: "RPRT_TRAINER",
                name: LocService.t('label_trainer_report'),
                localizationId: 'label_trainer_report',
                iconClass: 'ti-list',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/trainer-report',
            },
        ]
    },

    "PARTNERS": {
        id: "PARTNERS",
        name: LocService.t('label_partners'),
        localizationId: 'label_partners',
        iconClass: 'ti-hand-drag',
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
        route: '',
        subMenu: [
            {
                id: "PARTNERS",
                name: LocService.t('label_partners'),
                localizationId: 'label_partners',
                iconClass: 'ti-hand-drag',
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/company-payment'
            },
            {
                id: "COMPANY_PARTNERS",
                name: LocService.t('label_company_partners'),
                localizationId: 'label_company_partners',
                iconClass: 'ti-user',
                showBalance: false,
                role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
                route: '/company-partner'
            },
        ]
    },

    "MEMBERSHIPS": {
        id: "MEMBERSHIPS",
        name: LocService.t('label_mp_title'),
        localizationId: 'label_mp_title',
        iconClass: 'ti-package',
        showBalance: false,
        role: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
        route: '/membership-packages'
    },

    "ARTICLES": {
        id: "ARTICLES",
        name: LocService.t('label_articles'),
        localizationId: 'label_articles',
        iconClass: 'ti-package',
        showBalance: false,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_TRAINER'],
        route: '/articles'
    },

    "ARTICLE_REPORT": {
        id: "ARTICLE_REPORT",
        name: LocService.t('label_articles_report'),
        localizationId: 'label_articles_report',
        iconClass: 'ti-list',
        showBalance: false,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
        route: '/articles-report'
    },

    "INVOICES": {
        id: "INVOICES",
        name: LocService.t('label_invoices'),
        localizationId: 'label_invoices',
        iconClass: 'ti-view-list',
        showBalance: true,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
        route: '/invoices'
    },

    "COMPANIES": {
        id: "COMPANIES",
        name: LocService.t('label_companies'),
        localizationId: 'label_companies',
        iconClass: 'ti-pencil',
        showBalance: false,
        role: ['ROLE_SUPER_ADMIN'],
        route: '/companies'
    },

    "CAMPAIGN_COMPANY": {
        id: "CAMPAIGN_COMPANY",
        name: LocService.t('label_campaign_company'),
        localizationId: 'label_campaign_company',
        iconClass: 'ti-email',
        showBalance: false,
        role: ['ROLE_SUPER_ADMIN'],
        route: '/campaign-company'
    },

    "NUMBER_OF_TRAININGS": {
        id: "NUMBER_OF_TRAININGS",
        name: '',
        iconClass: '',
        showBalance: false,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_USER', 'ROLE_TRAINER'],
        route: '/number-of-trainings'
    },
    "MY_MEMBER": {
        id: "MY_MEMBER",
        name: LocService.t('label_membership'),
        localizationId: 'label_membership',
        iconClass: 'ti-money',
        showBalance: false,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_USER', 'ROLE_TRAINER'],
        route: '/my-payments'
    },
    "ACCOUNT": {
        id: "ACCOUNT",
        name: LocService.t('label_account'),
        localizationId: 'label_account',
        iconClass: 'ti-user',
        showBalance: false,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_USER', 'ROLE_TRAINER'],
        route: '/profile'
    },

    "DOCUMENTATIONS": {
        id: "DOCUMENTATIONS",
        name: LocService.t('label_documentations'),
        localizationId: 'label_documentations',
        iconClass: 'ti-book',
        showBalance: false,
        role: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
        route: '/admin-instruction'
    }

}

export default TAB_CONFIG


// WEBPACK FOOTER //
// ./src/services/tabConfig.js